export default "__VITE_ASSET__DTFMFQ51__"